'use strict';

/*global isEmpty */
/*global echo */
/*global Container*/
/*global services*/

function MapsContainer()  {
    Container.call(this);
}

MapsContainer.prototype = $.extend({}, Container.prototype, {
    construtor: 'MapsContainer',

    getMap: function getMap(mapID) {
        var _this = this;

        return _this.get(mapID);
    },

    addMap: function addMap(mapID, map) {
        var _this = this;

        _this.remove(mapID);
        _this.set(mapID, map);
        return _this;
    },

    removeMap: function removeMap(mapID) {
        var _this = this;

        _this.remove(mapID);
        return _this;
    },

    resizeMaps: function resizeMaps() {
        var _this = this;

        for(var mapID in _this.container) {
            if(mapID) {
                _this.container[mapID].resizeMap();
            }
        }
        return _this;
    }
});
